'use client';
import { BackofficeModal } from '@/components/modal';
import { BackofficeToast } from '@/components/toast';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { backofficeJWT } from '@repo/backoffice-api';
import { theme } from '@repo/ui';
import { getClientCookie, parseJwt, SendNavigatorData } from '@repo/utils';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';
import { store } from './store';
import { pushUserdata, resetUserdata } from './userdataSlice';

const LoadUserData = () => {
  const dispatch = useDispatch();
  const token = getClientCookie('token-backoffice');
  const decodedToken = parseJwt(token || '') as backofficeJWT;
  const pathname = usePathname();

  useEffect(() => {
    if (decodedToken && pathname !== '/login') {
      dispatch(
        pushUserdata({
          isAuth: true,
          username: decodedToken.sub,
          roles: decodedToken.roles || [],
          actions: decodedToken.actions || [],
        }),
      );
    } else {
      dispatch(resetUserdata());
    }
  }, [dispatch, decodedToken, pathname]);
  return <></>;
};

export function Providers({ children, nonce }: { children: React.ReactNode; nonce: string }) {
  useEffect(() => {
    SendNavigatorData({
      app: 'backoffice',
    });
  }, []);
  return (
    <ThemeProvider theme={theme({ nonce })}>
      <CssBaseline />
      <Provider store={store}>
        <LoadUserData />
        <BackofficeModal />
        <BackofficeToast />
        {children}
      </Provider>
    </ThemeProvider>
  );
}
